import React from 'react'
import {LabelList} from 'recharts'

export const getPercentageLabelList = () => (
  <LabelList
    dataKey={'percentage'}
    position="top"
    formatter={(value: any) => {
      return `${(value * 100).toFixed(1)}%`
    }}
    fontSize={11}
    fill={'#001719'}
  />
)
